module.exports = __webpack_public_path__ + "blog-placeholder.png?f00ac0012eb8fc460224405900aa9078";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-placeholder.png
// module id = 223
// module chunks = 0